module.exports = function() {
  return new Worker(__webpack_public_path__ + "4890e15d597f4aae5d27.worker.js");
};